import { render, staticRenderFns } from "./add-resource.vue?vue&type=template&id=61736cbc&scoped=true&"
import script from "./add-resource.vue?vue&type=script&lang=js&"
export * from "./add-resource.vue?vue&type=script&lang=js&"
import style0 from "./add-resource.vue?vue&type=style&index=0&id=61736cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61736cbc",
  null
  
)

export default component.exports